<template>
  <div class="top_nav">
    <el-header style="height: 70px">
      <router-link to="/" name="home" class="logo_box">
        <img class="logo" src="../assets/logo_new.png" />
        <div class="site_name">{{ siteName }}</div>
      </router-link>
      <el-menu
        class="el-menu-with-logo"
        mode="horizontal"
        :default-active="activeIndex"
      >
        <el-menu-item index="1" name="home" class="topNavBtn">
          <!-- <el-tooltip
            class="item"
            effect="dark"
            placement="bottom"
          > -->
            <router-link to="/">首页</router-link>
          </el-tooltip>
        </el-menu-item>
        <el-menu-item index="2" name="events" class="topNavBtn">
          <!-- <el-tooltip
            class="item"
            effect="dark"
            content="Events"
            placement="bottom"
          > -->
            <router-link :to="{ path: '/events', query: { page: 1 } }"
              >会议活动</router-link
            >
          </el-tooltip>
        </el-menu-item>
        <LoginInfoBox />
      </el-menu>
    </el-header>
  </div>
</template>

<script>
import LoginInfoBox from '@/components/LoginInfoBox.vue';
export default {
  name: 'TopNav',
  components: {
    LoginInfoBox,
  },
  props: {
    activeIndex: String,
    siteName: String,
  },

  data() {
    return {};
  },
};
</script>

<style scoped></style>
